import React from 'react';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
const mask = [/\d/, /\d/, '/', /\d/, /\d/];
const hint = 'MM/DD';
const pipe = createAutoCorrectedDatePipe('mm/dd');

const getValue = (value: any) => value;

// @types/react-text-mask doesn't declare the `getValue` prop, nor the custom
// ref instance (`.getValue()` / `.FormComponent`) this class relies on at
// runtime, so the component is treated as loosely typed here rather than
// fighting the shipped types.
const MaskedInputAny: React.ComponentType<any> = MaskedInput;

interface DOBInputProps {
  [key: string]: any;
}

class DOBInput extends React.Component<DOBInputProps> {

  static defaultProps = {};

  // Assigned by the ref callback post-mount. (`declare` would avoid the emitted
  // `this.input = void 0`, but CRA's babel plugin order rejects declare fields;
  // the emitted undefined is equivalent — every read falsy-checks it first.)
  input: any;

  getValue = (): any => {
    if (!this.input) {
      return null;
    }

    return this.input.getValue();
  };

  triggerFocus = () => this.input.FormComponent.triggerFocus();

  render() {
    return (
      <MaskedInputAny
        mask={mask}
        maskHint={hint}
        pipe={pipe}
        getValue={getValue}
        ref={(ref: any) => (this.input = ref)}
        {...this.props}
        placeholder='MM/DD'
      />
    );
  }
}

export default DOBInput;
